import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useConfig } from "../_util/config-context";
import { createRocket } from "../_util/create-rocket";
/**
 * DropdownFooter 定义放在 DropdownBox.tsx 中，避免 DropdownBox 通过
 * Dropdown.Footer 间接引用 Dropdown 组件，从而把 Popover / Select 等
 * 复杂依赖拖进 list / cascader 等只需要 DropdownBox 当容器的场景，
 * 造成模块循环依赖。
 */
export var DropdownFooter = createRocket("DropdownFooter", "div.@{prefix}-dropdown-box__footer");
/**
 * DropdownBox 抽出单独文件，避免走 Dropdown.tsx 的完整依赖链。
 *
 * list / cascader / select 等组件在 overlay 容器场景会依赖 DropdownBox，
 * 若通过 `../dropdown/Dropdown` 直接 import，会顺带拉入 Popover → Bubble →
 * Select / Pagination 等模块，在 ESM 运行环境下形成
 *   list → dropdown/Dropdown → popover → … → select → list/VirtualizedList
 * 的循环依赖，导致 `DropdownBox` export binding 在初始化期读取为 undefined，
 * 进而抛出 "Element type is invalid ... Check the render method of MirrorList"。
 *
 * 把 DropdownBox 抽到这个仅依赖 `_util/config-context` 与 `_type` 的轻量文件，
 * 即可彻底打破循环。Dropdown.tsx 从本文件 re-export，保持对外 API 不变。
 */
export var DropdownBox = React.forwardRef(function DropdownBox(_a, ref) {
    var _b;
    var className = _a.className, _c = _a.style, style = _c === void 0 ? {} : _c, children = _a.children, adaptable = _a.adaptable, footer = _a.footer, preventMouseDown = _a.preventMouseDown, stopPropagation = _a.stopPropagation, onMouseDown = _a.onMouseDown, props = __rest(_a, ["className", "style", "children", "adaptable", "footer", "preventMouseDown", "stopPropagation", "onMouseDown"]);
    var classPrefix = useConfig().classPrefix;
    if (!children) {
        return null;
    }
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-dropdown-box", (_b = {}, _b[classPrefix + "-dropdown-box--adapte"] = adaptable, _b), className), style: __assign({ position: "relative" }, style), 
        // 阻止点击时触发按钮 onBlur
        onMouseDown: function (event) {
            if (preventMouseDown) {
                event.preventDefault();
            }
            if (stopPropagation) {
                event.stopPropagation();
            }
            if (onMouseDown) {
                onMouseDown(event);
            }
        } }, props),
        children,
        footer && React.createElement(DropdownFooter, null, footer)));
});
DropdownBox.displayName = "DropdownBox";
//# sourceMappingURL=DropdownBox.js.map